import { z } from 'zod';
import { ControllerRenderProps } from 'react-hook-form';

// Create dynamic validation schema based on whether previous documents exist
export const createReleaseAuthorizationSchema = (
  hasPreviousDocuments: boolean,
) =>
  z
    .object({
      uploadedReleaseForm: z.array(z.any()).optional(),
      selectedPreviousDocuments: z.array(z.string()).optional(),
      noReleaseAuthorizationForms: z.boolean().optional(),
    })
    .refine(
      (data) => {
        // At least one option must be selected if there are previous documents
        return hasPreviousDocuments
          ? !!(
              data.uploadedReleaseForm?.length ||
              data.selectedPreviousDocuments?.length ||
              data.noReleaseAuthorizationForms
            )
          : !!(
              data.uploadedReleaseForm?.length ||
              data.noReleaseAuthorizationForms
            );
      },
      {
        message: hasPreviousDocuments
          ? 'Upload a release authorization form, select a previously submitted document, or declare that you do not have one.'
          : 'Upload a release authorization form or declare that you do not have one.',
        path: ['uploadedReleaseForm'],
      },
    );

// Default schema for when previous documents status is unknown
export const releaseAuthorizationSchema =
  createReleaseAuthorizationSchema(false);

export type ReleaseAuthorizationFormData = z.infer<
  typeof releaseAuthorizationSchema
>;

export type ReleaseAuthorizationFormFieldProps<
  T extends keyof ReleaseAuthorizationFormData,
> = {
  field: ControllerRenderProps<ReleaseAuthorizationFormData, T>;
};
